export async function compressJson(obj) {
    const json = JSON.stringify(obj);
    const encoder = new TextEncoder();
    const data = encoder.encode(json);

    const cs = new CompressionStream("gzip");
    const writer = cs.writable.getWriter();
    writer.write(data);
    writer.close();

    const compressed = await new Response(cs.readable).arrayBuffer();
    return new Uint8Array(compressed);
}

export async function decompressJson(uint8arr) {
    const ds = new DecompressionStream("gzip");
    const writer = ds.writable.getWriter();
    writer.write(uint8arr);
    writer.close();

    const decompressed = await new Response(ds.readable).text();
    return JSON.parse(decompressed);
}
